module.exports = __webpack_public_path__ + "img/main.e1bf4967.png";